import { render, staticRenderFns } from "./FichaRegistroEmpregado.vue?vue&type=template&id=2b79e824&scoped=true"
import script from "./FichaRegistroEmpregado.vue?vue&type=script&lang=js"
export * from "./FichaRegistroEmpregado.vue?vue&type=script&lang=js"
import style0 from "./FichaRegistroEmpregado.vue?vue&type=style&index=0&id=2b79e824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79e824",
  null
  
)

export default component.exports